import { cva } from "class-variance-authority";

export const ButtonIntent = {
  Default: "DEFAULT",
  Icon: "ICON",
  Black: "BLACK",
} as const;
export type ButtonIntent = (typeof ButtonIntent)[keyof typeof ButtonIntent];

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-3xl uppercase text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      intent: {
        [ButtonIntent.Default]: "bg-primary text-white hover:bg-primary/90",
        [ButtonIntent.Icon]: "bg-white hover:bg-white/90 rounded-full",
        [ButtonIntent.Black]: "bg-black text-white hover:bg-black/90",
      },
      size: {
        [ButtonIntent.Default]: "h-10 px-4 py-2",
        [ButtonIntent.Icon]: "h-11 w-11",
      },
    },
    defaultVariants: {
      intent: ButtonIntent.Default,
      size: ButtonIntent.Default,
    },
  }
);

export { buttonVariants };
